import { ConstantsService } from './../../services/constants-service';
import { IsiPersonReportDetail } from './../isi-report-detail/isi-report-detail.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'display-person-report',
  templateUrl: './display-person-report.component.html',
  styleUrls: ['./display-person-report.component.css']
})
export class DisplayPersonReportComponent {
  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  @Input()
  reportData: IsiPersonReportDetail;

  @Input()
  listName: string;
  constructor() { }

  toggleList(reportData: IsiPersonReportDetail) {
    this.reportData.open = !reportData.open;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/display-person-report/display-person-report.component.ts